<template>
  <div class="container">
    <img class="bgImg" :src="detail.imageUrl" alt="" />
    <div class="middleBox">
      <div class="middleContent">
        <div class="userBox">
          <div class="userBg">
            <div style="margin-right: 20px">biệt danh：{{ userInfo.nickName }}</div>
            <div>id：{{ userInfo.idNo }}</div>
          </div>
        </div>
        <div v-for="(item, index) in detail.taskSetupVoList" class="progressBox">
          <div class="taskTitle">
            <img class="star" src="@/assets/images/activity_star.png" alt="" />
            <span>{{ item.title }}</span>
            <img class="star" src="@/assets/images/activity_star.png" alt="" />
          </div>
          <div class="subTitle">{{ item.description }}</div>
          <div v-for="child in item.taskSetupRequireList" class="childItem">
            <el-progress style="width: 100%;" :percentage="(child.userFinishTimes / child.taskTimes) * 100"
              :show-text="false" define-back-color="rgba(255, 255, 255, 0.3)"
              :color="index == 0 ? '#22FEE1' : '#FE41EE'" :stroke-width="16" class="commonProgress"></el-progress>
            <div class="childTitle">
              <span class="text">{{ child.taskKeyLabel }}</span>
              <span class="num">{{ child.userFinishTimes }}/ {{ child.taskTimes }}</span>
            </div>
          </div>
        </div>
        <!-- 活动未启用 -->
        <div class="endScene" v-if="activityStatus == 0">
          <div class="endText">Hoạt động chưa được kích hoạt</div>
        </div>

        <div v-else>
          <div class="userBox" v-if="!activityFinished">
            <div style="color: #f8ff39; margin-bottom: 8px; opacity: 0.6">{{ timeText }}：</div>
            <el-statistic :value="endTime" time-indices title="" format="DDd HHh mm:ss" @finish="handleFinish"
              :value-style="{ color: '#F8FF39', fontSize: '16px' }">
            </el-statistic>
          </div>
          <!-- 活动结束 -->
          <div class="endScene" v-else>
            <div class="endText">Hoạt động đã kết thúc</div>
          </div>
        </div>

      </div>
    </div>
    <img class="bgImg" style="margin-top: -1px;" :src="detail.activityRule" alt="" />
  </div>
</template>
<script>
import { serverApi } from "@/server/index";
export default {
  name: "activityDetail",
  data() {
    return {
      textObj: {
        en: {
          onlineService: "Live Chat",
        },
        vi: {
          onlineService: "Liên hệ",
        },
      },
      lang: "en",
      active: 0,
      userInfo: { nickName: "", idNo: "" },
      detail: {
        taskSetupVoList: [],
      },
      endTime: 0,
      timeText: 'Kết thúc',
      activityFinished: false, // 是否已结束
      activityStatus: -1, // 活动状态：0未启用，1启用
    };
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 768;
    },
  },
  created() {
    this.init();
    this.getDetail();
  },
  methods: {
    init() {
      this.lang = localStorage.getItem("lang") || "en";
    },
    getDetail() {
      // localStorage.setItem('token',this.$route.query.token);
      // console.log(this.$route.query);
      const query = this.$route.query;
      serverApi
        .requestApi(
          "get",
          "/chat_app/promoteActivity/info",
          { activityId: query.id },
          { token: query.token, tokenId: query.tokenId }
        )
        .then((res) => {
          // console.log(res);
          this.detail = res.data.data || {};
          const nowTime = new Date(res.data.data.systemTime).getTime();
          const startTime = new Date(res.data.data.startTime).getTime();
          this.activityStatus = res.data.data.status;
          console.log(this.activityStatus);
          if (nowTime < startTime) {
            // 未开始
            this.endTime = startTime;
            this.timeText = 'Khoảng cách đến khi hoạt động bắt đầu';
          } else {
            // 进行中
            this.timeText = 'Khoảng cách đến khi hoạt động kết thúc';
            this.endTime = new Date(res.data.data.endTime).getTime();
          }
          this.activityFinished = false;
        });
      this.userInfo = {
        nickName: query.nickName,
        idNo: query.idNo,
      };
    },
    // 活动结束
    handleFinish() {
      this.activityFinished = true;
    }
  },
};
</script>

<style scoped>
.container {
  margin: 0;
  padding: 0;
}

.mobileShow {
  display: none !important;

  @media screen and (max-width: 768px) {
    display: block !important;
  }
}

.pcShow {
  display: block !important;

  @media screen and (max-width: 768px) {
    display: none !important;
  }
}

.bgImg {
  width: 100%;
  display: block;
}

.middleBox {
  position: relative;
  margin: 0;
}

.middleContent {
  background: url("../assets/images/activity_bg.png");
}

.userBox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  color: #fff;
}

.userBg {
  background-color: rgba(255, 255, 255, 0.12);
  line-height: 23px;
  display: inline-flex;
  padding: 0 10px;
  width: auto;
  border-radius: 12px;
}

.progressBox {
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding: 0 27px;
  box-sizing: border-box;
}

.taskTitle {
  font-size: 20px;
  margin-bottom: 5px;
  font-weight: bold;
  display: flex;
  align-items: center;
  text-align: center;

  span {
    margin: 0 10px
  }
}

.star {
  width: 16px;
  height: 16px;
}

.subTitle {
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 20px;
  text-align: center;
}

.childItem {
  width: 100%;
  margin-bottom: 20px;
}

.childTitle {
  text-align: center;
  margin-top: 8px;
}

.text {
  color: rgba(255, 255, 255, 0.7);
}

.commonProgress {
  border: 1px solid #fff;
  border-radius: 16px;
  overflow: hidden;
}

.centerBgImg {
  width: 100%;
  height: auto;
  object-fit: cover;
  display: block;
}

.endScene {
  text-align: center;
  color: #f8ff39;
  padding: 20px 0;
}

.endText {
  color: #f8ff39
}
</style>



// WEBPACK FOOTER //
// src/components/ActivityDetail.vue